import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import BreadcrumbItem from "../../atoms/BreadcrumbItem";

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
`;

export interface BreadcrumbData {
  text: string;
  href?: string;
}

interface BreadcrumbProps {
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ className }) => {
  const location = useLocation();

  const generateBreadcrumbs = (): BreadcrumbData[] => {
    const path = location.pathname;
    const segments = path.split("/").filter((segment) => segment !== "");

    const breadcrumbs: BreadcrumbData[] = [];

    // 홈 경로
    if (path === "/dashboard") {
      breadcrumbs.push({ text: "홈" });
    } else {
      breadcrumbs.push({ text: "홈", href: "/dashboard" });
    }

    // 경로 세그먼트별 처리
    if (segments.length > 0) {
      for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        const isLast = i === segments.length - 1;

        if (segment === "dashboard") {
          continue; // 이미 홈으로 처리됨
        } else if (segment === "patients") {
          // 환자 ID가 있는 경우
          if (i + 1 < segments.length) {
            const patientId = segments[i + 1];
            const href = isLast ? undefined : `/patients/${patientId}`;
            breadcrumbs.push({
              text: `환자 ${patientId}`,
              href: href,
            });
            i++; // 다음 세그먼트(patientId) 건너뛰기
          }
        } else if (segment === "reviews") {
          // 보고서 ID가 있는 경우
          if (i + 1 < segments.length) {
            const reviewId = segments[i + 1];
            breadcrumbs.push({
              text: `보고서 ${reviewId}`,
            });
            i++; // 다음 세그먼트(reviewId) 건너뛰기
          } else {
            breadcrumbs.push({ text: "보고서" });
          }
        } else if (segment === "admin") {
          breadcrumbs.push({ text: "관리자", href: isLast ? undefined : "/admin" });
        } else if (segment === "users") {
          breadcrumbs.push({ text: "사용자 관리" });
        } else if (segment === "drugs") {
          breadcrumbs.push({ text: "약물 관리" });
        } else if (segment === "prompts") {
          breadcrumbs.push({ text: "프롬프트 관리" });
        }
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  return (
    <BreadcrumbContainer className={className}>
      {breadcrumbs.map((breadcrumb, index) => (
        <BreadcrumbItem
          key={index}
          text={breadcrumb.text}
          href={breadcrumb.href}
          isLast={index === breadcrumbs.length - 1}
          showChevron={true}
        />
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
